import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, indexedDBLocalPersistence, initializeAuth, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyC9JMgrTqqqETmQV5ocwPlwrMGIFDNLVd8",
  authDomain: "babybook-70058.firebaseapp.com",
  projectId: "babybook-70058",
  storageBucket: "babybook-70058.firebasestorage.app",
  messagingSenderId: "817980248436",
  appId: "1:817980248436:web:e27bc261d45c2d171bdc21",
  measurementId: "G-5JJVGSW2BD"
};

const app = initializeApp(firebaseConfig);

// Use indexedDB persistence for Capacitor, regular for web
let auth;
if (typeof window !== 'undefined' && window.Capacitor) {
  auth = initializeAuth(app, {
    persistence: indexedDBLocalPersistence
  });
} else {
  auth = getAuth(app);
}

export { auth };
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

export default app;